export const SET_USER_DATA = 'INDICATORS_SET_USER_DATA'
export const SET_DISPLAYING_TYPE = 'INDICATORS_SET_DISPLAYING_TYPE'
export const SET_VISITOR_INDICATORS = 'INDICATORS_SET_VISITOR_INDICATORS'

export const setUserData = (data) => {
  return { type: SET_USER_DATA, data: data }
}
export const setDisplayType = (type) => {
  return { type: SET_DISPLAYING_TYPE, data: type }
}
export const setVisitorIndicators = (indicators) => {
  return { type: SET_VISITOR_INDICATORS, data: indicators }
}
